import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: 'Cascadia Mono';
        src: 
            url(${process.env.PUBLIC_URL}/fonts/cascadia-mono.woff2) format('woff2'),
            url(${process.env.PUBLIC_URL}/fonts/cascadia-mono.ttf) format('ttf'),
            url(${process.env.PUBLIC_URL}/fonts/cascadia-mono.otf) format('otf');
    }
`;

export default GlobalStyles;